import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function BoothList() {
  const [booths, setBooths] = useState([]);
  const [branches, setBranches] = useState([]);
  const [searchAddress, setSearchAddress] = useState('');
  const [searchTown, setSearchTown] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const [searchBranchName, setSearchBranchName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBooths = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/booth/active-booth');
        const boothData = await Promise.all(
          response.data.map(async (booth) => {
            const branchResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/branch/${booth.branchID}`);
            return {
              ...booth,
              branchName: branchResponse.data.branchName,
              address: branchResponse.data.address,
              town: branchResponse.data.town,
              city: branchResponse.data.city,
            };
          })
        );
        setBooths(boothData);
      } catch (error) {
        console.error('Error fetching booth data:', error);
      }
    };

    const fetchBranches = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/branch/paging?status=Active');
        setBranches(response.data);
      } catch (error) {
        console.error('Error fetching branch data:', error);
      }
    };

    fetchBooths();
    fetchBranches();
  }, []);

  const handleBoothClick = (boothID) => {
    navigate(`/boothdetail/${boothID}`);
  };

  const handleCityChange = (e) => {
    setSearchCity(e.target.value);
  };

  const handleTownChange = (e) => {
    setSearchTown(e.target.value);
  };

  const handleAddressChange = (e) => {
    setSearchAddress(e.target.value);
  };

  const handleBranchNameChange = (e) => {
    setSearchBranchName(e.target.value);
  };

  const filteredBooths = booths.filter(booth => {
    return (
      (searchBranchName === '' || booth.branchName === searchBranchName) &&
      (searchAddress === '' || booth.address === searchAddress) &&
      (searchTown === '' || booth.town === searchTown) &&
      (searchCity === '' || booth.city === searchCity)
    );
  });

  return (
    <div className="container mx-auto py-8">
      <div className="w-full p-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Booths</h2>
        
        {/* Horizontal Search Filters */}
        <div className="flex items-center mb-8 space-x-4">
          <div className="flex items-center">
            <select
              value={searchBranchName}
              onChange={handleBranchNameChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select Branch Name</option>
              {Array.from(new Set(branches.map(branch => branch.branchName))).map(branchName => (
                <option key={branchName} value={branchName}>{branchName}</option>
              ))}
            </select>
          </div>

          <div className="flex items-center">
            <select
              value={searchAddress}
              onChange={handleAddressChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select Address</option>
              {Array.from(new Set(branches.map(branch => branch.address))).map(address => (
                <option key={address} value={address}>{address}</option>
              ))}
            </select>
          </div>
         
          <div className="flex items-center">
            <select
              value={searchTown}
              onChange={handleTownChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select Town</option>
              {Array.from(new Set(branches.map(branch => branch.town))).map(town => (
                <option key={town} value={town}>{town}</option>
              ))}
            </select>
          </div>
         
          <div className="flex items-center">
            <select
              value={searchCity}
              onChange={handleCityChange}
              className="px-4 py-2 border rounded-lg"
            >
              <option value="">Select City</option>
              {Array.from(new Set(branches.map(branch => branch.city))).map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredBooths.map(booth => (
            <div 
              key={booth.boothID} 
              className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-transform hover:scale-105"
              onClick={() => handleBoothClick(booth.boothID)} // On click, navigate to BoothDetail
            >
             <img
  src={booth.boothPhotos[0]?.boothPhotoUrl || 'https://via.placeholder.com/300x300'} 
  alt={booth.boothName}
  className="w-full h-[300px] object-cover"
/>

              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{booth.boothName}</h3>
                <p className="text-gray-600 mb-1"><span className="font-bold">Branch:</span> {booth.branchName}</p>
                <p className="text-gray-600 mb-1"><span className="font-bold">Address:</span> {booth.address}, {booth.town}, {booth.city}</p>
                <p className="text-gray-600 mb-1"><span className="font-bold">Background Color:</span> {booth.backgroundColor}</p>
                <div className="flex justify-between text-gray-600">
                  <p><span className="font-bold">Concept:</span> {booth.concept}</p>
                  <p><span className="font-bold">People:</span> {booth.peopleInBooth}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
